export default {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    forgotPassword: '/auth/password-forgot',
    resetPassword: '/auth/password-reset/:token',
    invitationSignup: '/auth/invitations/signup',
  },
  public: {
    unitsPreview: '/rental-application/invitations/:inviteId',
    guestApply: '/units/:unitId/apply',
    recertificationApply: '/recertification/apply/:inviteId',
    OptOutPage: '/opt-out',
  },
  app: {
    comingSoon: '/app/coming-soon',
    organizations: '/app/organizations',
    phas: '/app/phas',
    phasCalls: '/app/pha/calls',
    addPha: '/app/pha/add',
    phaMembers: '/app/pha-members',
    phaInvitations: '/app/invitations',
    phaProgrammes: '/app/programmes',
    organizationMembers: '/app/organization-members',
    insuranedApplications: '/app/insuranced-applications',
    buildings: '/app/properties',
    buildingDetail: '/app/properties/:unitId',
    applications: '/app/applications',
    recertificationApplications: '/app/recertification-application',
    createApplication: '/app/applications/create',
    application: (applicationId: number) =>
      `/app/applications/${applicationId}`,
    units: '/app/units',
    guestCard: '/app/guestCard',
    support: '/app/support',
    pendingPayrolls: '/app/support/pending-payrolls/:applicationId',
    processedPayrolls: '/app/support/processed-payrolls/:applicationId',
    pendingProperties: '/app/support/pending-properties/:organisationId',
    rejectedBankStatements:
      '/app/support/rejected_bank_statement/:applicationId',
    bankEntry: '/app/support/bank-entry',
    referrals: '/app/referrals',
    settings: '/app/settings',
    newApplications: '/app/new-applications',
    uploader: '/app/uploader',
    configuration: '/app/configuration',
    upload: {
      onboarding: '/overview/rental-application/units/:unitId',
      terms: '/rental-application/units/:unitId/terms-conditions',
      termsExtended:
        '/rental-application/units/:unitId/terms-conditions-extended',
      yourInformation: '/rental-application/units/:unitId/your-information',
      phaVoucher: '/rental-application/units/:unitId/pha-voucher',
      govtId: '/rental-application/units/:unitId/govtId',
      coapplicants:
        '/rental-application/units/:unitId/coapplications-guarantor',
      paymentDetails: '/rental-application/units/:unitId/payment-details',
      crs: '/rental-application/units/:unitId/credit-report',
      bankStatements: '/rental-application/units/:unitId/bank-statements',
      employmentInformation:
        '/rental-application/units/:unitId/employment-information',
      taxReturns: '/rental-application/units/:unitId/tax-returns',
      residenceHistory: '/rental-application/units/:unitId/residence-history',
      additionalInformationExtended:
        '/rental-application/units/:unitId/additional-information',
      submission: '/rental-application/units/:unitId/submission',
    },
    recertification: {
      create: '/app/recertification/create',
      apply: {
        landing: '/recertification/apply/',
        termsAndCondition:
          '/recertification/apply/:inviteId/terms-and-condition',
        yourInformation: '/recertification/apply/:inviteId/your-information',
        additionalInformation:
          '/recertification/apply/:inviteId/additional-information',
        govtId: '/recertification/apply/:inviteId/govt-id',
        bankStatements: '/recertification/apply/:inviteId/bank-statements',
        employmentInformation:
          '/recertification/apply/:inviteId/employment-information',
        additionalDocuments:
          '/recertification/apply/:inviteId/additional-documents',
      },
      recertification: '/app/recertification',
      list: '/app/recertification-applications',
      show: (id: number): string => `/app/recertification-applications/${id}`,
      invitesList: '/app/recertification/invites',
    },
    suggestions: '/app/property-suggestions',
    viewSuggestion: '/app/property-suggestions/:applicationId/unit/:unitId',
    systemLogs: '/app/systemLogs',
    tenantMonitoring: '/app/recertification',
    getInsurence: '/app/insurence',
    help: '/app/help',
  },
  user: {
    profile: {
      view: '/user/:user_id',
      edit: '/user/:user_id/edit',
    },
    phaUserInvitation: '/users/invitations/:phaInviteId',
  },
  documents: {
    confirmDetails: '/documents/:appId/confirm-details',
    insurance: '/documents/:appId/insurance-subscription',
    signLease: '/documents/:appId/sign-lease',
  },
};
